<template>
    <div>
          <el-dialog
            title="下载列表"
            :visible.sync="showDialog"
            width="60%"
            :before-close="handleClose"
            >
              <el-row>
                 <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="55" ></el-table-column>
                    <el-table-column prop="applyTime" label="申请时间" align="center" width="200px" > </el-table-column>
                    <el-table-column prop="operator" label="操作人" align="center" width="130px" > </el-table-column>
                    <el-table-column prop="fileName" label="文件名" align="center" show-overflow-tooltip=""> </el-table-column>
                    <el-table-column prop="status" label="状态" align="center" width="100px"> 
                         <template slot-scope="scope">
                              <span class="statusColor">{{scope.row.status == '1' ? '已完成':'下载中'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="discount" label="操作" align="center" width="100px"> 
                        <template slot-scope="scope">
                              <div class="toolBtn" @click="downLoadFile(scope.row)">下载</div>
                        </template>
                    </el-table-column>
                    
                  </el-table>
                      <div class="footerBox" v-if="total>10">
                        <!-- 分页区域 -->
                        <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="queryInfo.currPage"
                          :page-sizes="[10, 20, 30, 50]"
                          :page-size="queryInfo.pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"
                        ></el-pagination>
                      </div>
              </el-row>
             <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
                <!-- <el-button type="primary" @click="confirm">确 定</el-button> -->
            </span>
          </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            total:0,
           showDialog:false,
           tableData:[
            {
               applyTime:'2023-08-14 20:24:54',
               operator:'张三',
               fileName:'满品客大饭堂习友路店_优惠券明细_导出_1692071601619.zip',
               status:'1',
            },
             {
               applyTime:'2023-08-14 10:46:11',
               operator:'李四',
               fileName:'满品客大饭堂习友路店_优惠券明细_导出_1692071601222.zip',
               status:'1',
            },
           ],
           queryInfo:{
            pageSize: 10,
            currPage: 1,
            condition:{},
          },
        }
    },
     props:{
        dialogListVisible:{
            type: Boolean,
            default:false,
        }
     },
     watch:{
        dialogListVisible:{
            handler(newVal,oldVal){
                this.showDialog = newVal
            },
            deep:true,
            immediate:true,
        }
     },
      methods:{
        //下载文件
        downLoadFile(row){
        //window.open(downloadPath)
        },
        handleClose(){
             this.$emit('handleClose',false)
             this.showDialog = false
        },
        // 监听 pagesize改变的事件
        handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        //   this.getListData();
        },
        // 监听 页码值 改变事件
        handleCurrentChange(newSize) {
        this.queryInfo.currPage = newSize;
        //   this.getListData();
        },
     }
}
</script>

<style lang="less" scoped>
 /deep/ .el-table th>.cell{
    font-size: 15px;
    color: #222;
    font-weight: 500;
 }
 /deep/ .el-dialog__header{
    border-bottom: 1px solid #e5e5e5;
 }
 .toolBtn{
    color: #f59a23;
    font-size: 14px;
    cursor: pointer;
 }
 /deep/ .el-table th, /deep/ .el-table tr{
    font-size: 14px;
    color: #222;
 }
 .statusColor {
    color: green;
 }
</style>